import TrainingAssistant from "./module/training-assistant";

const trainingAssistant = new TrainingAssistant();

const alpineData = () => {
  return {
    step: 1,
    next() {
      this.step++;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    prev() {
      this.resetSteps(this.step);
      this.step--;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    setStep(step) {
      if (step < this.step) {
        this.resetSteps(step + 1);
      }
      this.step = step;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    elementsSteps: [],
    selectedElementsSteps: [],
    elementsResult: [],

    trainingAssistantLoading: false,
    trainingAssistantLoadingResultText: false,

    klassigruppenArray: (wp_metis.wp_theme === 'HK Master'
      ?
        [
          wp_metis['metisKursKlassigruppenIdTargetgroup'],
          wp_metis['metisKursKlassigruppenIdThemenwelt'],
          wp_metis['metisKursKlassigruppenIdCourseduration'],
          wp_metis['metisKursKlassigruppenIdTimemodel'],
        ]
      :
        [
          wp_metis['metisKursKlassigruppenIdThemenwelt'],
          wp_metis['metisKursKlassigruppenIdAbschluss'],
          wp_metis['metisKursKlassigruppenIdCourseduration'],
        ]
    ),

    filterFunctionFields: (wp_metis.wp_theme === 'HK Master'
      ?
        [
          {
            postType: "targetgroup",
            searchKeyName: "object_id",
            imageField: "icon",
            defaultImageField: "targetgroup_icon",
            extraCustomFields: ["color"]
          },

          {
            postType: "themenwelt",
            searchKeyName: "object_id",
            imageField:  "icon",
            defaultImageField: "themenwelt_icon",
            extraCustomFields: []
          },

          {
            postType: "courseduration",
            searchKeyName: "object_id",
            imageField: "icon",
            defaultImageField: "courseduration_icon",
            extraCustomFields: ["background"]
          },

          {
            postType: "timemodel",
            searchKeyName: "object_id",
            imageField: "icon",
            defaultImageField: "timemodel_icon",
            extraCustomFields: ["background"]
          },
        ]
      :
        [

          {
            postType: "themenwelt",
            searchKeyName: "object_id",
            imageField:  "icon_animated",
            defaultImageField: null,
            extraCustomFields: []
          },

          {
            postType: "abschluss",
            searchKeyName: "object_id",
            imageField: "icon_animated",
            defaultImageField: null,
            extraCustomFields: []
          },

          {
            postType: "courseduration",
            searchKeyName: "object_id",
            imageField: "icon_animated",
            defaultImageField: null,
            extraCustomFields: ["background"]
          },

        ]
    ),

    resetSteps(step) {
      switch (step) {
        case 2:
          this.elementsSteps[1] = [];
          this.selectedElementsSteps[1] = [];
          this.uncheckInputs(1);
        case 3:
          this.elementsSteps[2] = [];
          this.selectedElementsSteps[2] = [];
          this.uncheckInputs(2);
        case 4:
          this.elementsSteps[3] = [];
          this.selectedElementsSteps[3] = [];
          this.uncheckInputs(3);
        default:
          this.selectedElementsSteps[3] = [];
          this.uncheckInputs(4);
          break;
      }
    },

    trainingAssistantInit: function() {
      for(let i = 0; i < this.klassigruppenArray.length; i++) {
        this.elementsSteps.push([]);
        this.selectedElementsSteps.push([]);
      }
    },

    uncheckInputs(step) {
      let inputs = document.querySelectorAll("#page-" + step + " input");
      if (inputs && inputs.length) {
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].type == "checkbox" || inputs[i].type == "radio") {
            inputs[i].checked = false;
          }
        }
      }
    },

    addSelection: function (step, selection) {
      const themeIndex = this.selectedElementsSteps[step].findIndex(
        (t) => t.id === selection.id
      );

      if (themeIndex == -1) {
        this.selectedElementsSteps[step].push(selection);
      } else {
        this.selectedElementsSteps[step].splice(themeIndex, 1);
      }
    },

    filterStep: async function (step, ignoreEmptyObject = false, selectAll = false) {
      let that = this;

      this.trainingAssistantLoading = true;
      if (step == this.elementsSteps.length) {
        this.trainingAssistantLoadingResultText = true;
      }


      if (step == 0 || step == this.elementsSteps.length || (ignoreEmptyObject || this.selectedElementsSteps[step] != null)) {

        // apply filters
        let filterObject = (step == 0 ? null : []);
        for (let i = 0; i < step; i++) {

          let temp = [];
          if (selectAll && i == step - 1) {
            this.selectedElementsSteps[i] = [...this.elementsSteps[i]];
          }

          if (this.selectedElementsSteps[i].length > 0) {
            temp = {
              klassigruppeId: this.klassigruppenArray[i],
              klassiIds: this.selectedElementsSteps[i].map( element => element.id)
            }
          }

          filterObject.push(temp);
        }

        let result = null;

        if (step == this.elementsSteps.length) { // Result

          // console.log('Filters Result', step, filterObject);

        } else {  // Step

          // console.log('Filters Step', step, filterObject);

          result = await trainingAssistant.getAllKursKlassimerkmaleByKlassigruppe(
            this.klassigruppenArray[step],
            filterObject
          );

        }

        if (!ignoreEmptyObject) {
          if (typeof gtag !== "undefined") {
            if (step !== 0) {
              const names  = this.selectedElementsSteps[step - 1] ? this.selectedElementsSteps[step - 1].map(e => e.klassiname) : [];
              const name = names.join(", ");
              window.gtag_custom_func('TrainingAssistantStep', {step: step, name: name});
            }
          }
        }

        if (step == this.elementsSteps.length) { // Result

          document.dispatchEvent(new CustomEvent('AssistantFinishedResults', { detail: filterObject}));

          setTimeout(function() {

            that.elementsResult = result;
            that.setStep("Result");
            const calendly = document.querySelector('.calendly-badge-widget');
            if(calendly) {
              calendly.classList.add('d-block')
            }

            that.trainingAssistantLoading = false;
            that.trainingAssistantLoadingResultText = false;
          }, 1000);


          // console.log('Result Result', step, result);

        } else {  // Step

          if (result && result.length && result.length > 0) {

            let wpObjects = await this.ajaxCall(
              result.map((element) => element.id),
              this.filterFunctionFields[step].postType,
              this.filterFunctionFields[step].searchKeyName,
              this.filterFunctionFields[step].imageField,
              this.filterFunctionFields[step].defaultImageField,
              this.filterFunctionFields[step].extraCustomFields,

            );
            wpObjects = JSON.parse(wpObjects);
            if (wpObjects && wpObjects.length && wpObjects.length > 0) {
              result.forEach((r, index) => {
                if (wpObjects[index]) {
                  result[index].imageUrl = wpObjects[index].imageUrl;
                  this.filterFunctionFields[step].extraCustomFields.forEach(fieldName => {
                    result[index][fieldName] = wpObjects[index][fieldName];
                  });
                } else {
                  console.log("Post for Object", result[index], "not found");
                }
              });
            }

            // console.log('Result Step', step, result);

            this.elementsSteps[step] = [...result];
            setTimeout(function() {
              document.dispatchEvent(new CustomEvent("refresh-lotties"));
              that.setStep(step + 1);
              that.trainingAssistantLoading = false;
            }, 100)
          }
          this.trainingAssistantLoading = false;
        }

      } else {
        console.log("No Results for Step " + step + ", continue");
        this.filterStep(step + 1, true);
        this.trainingAssistantLoading = false;
      }
    },

    ajaxCall: async function (
      searchValues,
      postType,
      searchKeyName,
      imageField,
      defaultImageField,
      extraCustomFields
    ) {
      const result = jQuery.ajax({
        type: "post",
        url: ajaxurl,
        data: {
          action: "trainingAssistantGetPosts",
          data: {
            postType: postType,
            searchKeyName: searchKeyName,
            searchValues: searchValues,
            imageField: imageField,
            defaultImageField: defaultImageField,
            extraCustomFields: extraCustomFields,
          },
        },
        success: function (response) {
          // console.log("Ajax Image Response:", response);
          return response;
        },
        error: function (error) {
          console.log("Error", error);
          return false;
        },
      });
      return result;
    },

    isChecked: function(step, elementId) {
      if (this.selectedElementsSteps[step].find(stepElement => stepElement.id === elementId)) {
        return true;
      }
      return false;
    }
  };
};

if(!window.alpineData) {
  window.alpineData = {};
}
window.alpineData.trainingAssistant = alpineData;
